// extracted by css-extract-rspack-plugin
module.exports =  {"inventoryViewerHeader":"InventoryViewerHeader__inventoryViewerHeader___riFD0"};